import { render, staticRenderFns } from "./priceColorize.vue?vue&type=template&id=cd95b69c&scoped=true"
import script from "./priceColorize.vue?vue&type=script&lang=js"
export * from "./priceColorize.vue?vue&type=script&lang=js"
import style0 from "./priceColorize.vue?vue&type=style&index=0&id=cd95b69c&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd95b69c",
  null
  
)

export default component.exports